//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { DateTime, Duration } from "luxon";

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    admin_AddAdmin(netId: string | undefined): Promise<Admin> {
        let url_ = this.baseUrl + "/Admins?";
        if (netId === null)
            throw new Error("The parameter 'netId' cannot be null.");
        else if (netId !== undefined)
            url_ += "netId=" + encodeURIComponent("" + netId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_AddAdmin(_response);
        });
    }

    protected processAdmin_AddAdmin(response: Response): Promise<Admin> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Admin>(null as any);
    }

    admin_GetAdmins(): Promise<Admin[]> {
        let url_ = this.baseUrl + "/Admins";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_GetAdmins(_response);
        });
    }

    protected processAdmin_GetAdmins(response: Response): Promise<Admin[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Admin.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Admin[]>(null as any);
    }

    admin_DeleteAdmin(adminId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Admins/{adminId}";
        if (adminId === undefined || adminId === null)
            throw new Error("The parameter 'adminId' must be defined.");
        url_ = url_.replace("{adminId}", encodeURIComponent("" + adminId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_DeleteAdmin(_response);
        });
    }

    protected processAdmin_DeleteAdmin(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    admin_GetAdmin(adminId: string): Promise<Admin> {
        let url_ = this.baseUrl + "/Admins/{adminId}";
        if (adminId === undefined || adminId === null)
            throw new Error("The parameter 'adminId' must be defined.");
        url_ = url_.replace("{adminId}", encodeURIComponent("" + adminId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_GetAdmin(_response);
        });
    }

    protected processAdmin_GetAdmin(response: Response): Promise<Admin> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Admin>(null as any);
    }

    admin_UpdateAllStudentsFromDW(): Promise<DWStudentProfileSynchronization> {
        let url_ = this.baseUrl + "/UpdateAllStudentsFromDW";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_UpdateAllStudentsFromDW(_response);
        });
    }

    protected processAdmin_UpdateAllStudentsFromDW(response: Response): Promise<DWStudentProfileSynchronization> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DWStudentProfileSynchronization.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DWStudentProfileSynchronization>(null as any);
    }

    admin_GetLastDWStudentProfileSyncTimestamp(): Promise<string> {
        let url_ = this.baseUrl + "/GetLastDWStudentProfileSyncTimestamp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_GetLastDWStudentProfileSyncTimestamp(_response);
        });
    }

    protected processAdmin_GetLastDWStudentProfileSyncTimestamp(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    admin_GetReferenceItems(type: ReferenceType | undefined): Promise<ReferenceItemDTO[]> {
        let url_ = this.baseUrl + "/GetReferenceItem?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_GetReferenceItems(_response);
        });
    }

    protected processAdmin_GetReferenceItems(response: Response): Promise<ReferenceItemDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferenceItemDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferenceItemDTO[]>(null as any);
    }

    admin_AddReferenceItem(type: ReferenceType | undefined, name: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/AddReferenceItem?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_AddReferenceItem(_response);
        });
    }

    protected processAdmin_AddReferenceItem(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    admin_UpdateReferenceItem(type: ReferenceType | undefined, id: string | undefined, newName: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/UpdateReferenceItem?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newName === null)
            throw new Error("The parameter 'newName' cannot be null.");
        else if (newName !== undefined)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_UpdateReferenceItem(_response);
        });
    }

    protected processAdmin_UpdateReferenceItem(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    admin_RemoveReferenceItem(type: ReferenceType | undefined, id: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/DeleteReferenceItem?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_RemoveReferenceItem(_response);
        });
    }

    protected processAdmin_RemoveReferenceItem(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    admin_GetColleges(): Promise<College[]> {
        let url_ = this.baseUrl + "/GetColleges";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_GetColleges(_response);
        });
    }

    protected processAdmin_GetColleges(response: Response): Promise<College[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(College.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<College[]>(null as any);
    }

    admin_AddStudentAward(model: StudentAwardDTO): Promise<StudentAwardProfile> {
        let url_ = this.baseUrl + "/StudentAwards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_AddStudentAward(_response);
        });
    }

    protected processAdmin_AddStudentAward(response: Response): Promise<StudentAwardProfile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentAwardProfile.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentAwardProfile>(null as any);
    }

    admin_DeleteStudentAward(id: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/DeleteStudentAward?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_DeleteStudentAward(_response);
        });
    }

    protected processAdmin_DeleteStudentAward(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    admin_EditStudentAward(id: string | undefined, model: StudentAwardDTO): Promise<StudentAwardProfile> {
        let url_ = this.baseUrl + "/EditStudentAward?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_EditStudentAward(_response);
        });
    }

    protected processAdmin_EditStudentAward(response: Response): Promise<StudentAwardProfile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentAwardProfile.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentAwardProfile>(null as any);
    }

    admin_GetNotes(studentId: string | undefined): Promise<NotesWithAuthor[]> {
        let url_ = this.baseUrl + "/Notes?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_GetNotes(_response);
        });
    }

    protected processAdmin_GetNotes(response: Response): Promise<NotesWithAuthor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotesWithAuthor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotesWithAuthor[]>(null as any);
    }

    admin_AddNote(userIdAdvisor: string | undefined, studentId: string | undefined, content: string | undefined): Promise<Note> {
        let url_ = this.baseUrl + "/Notes?";
        if (userIdAdvisor === null)
            throw new Error("The parameter 'userIdAdvisor' cannot be null.");
        else if (userIdAdvisor !== undefined)
            url_ += "userIdAdvisor=" + encodeURIComponent("" + userIdAdvisor) + "&";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (content === null)
            throw new Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_AddNote(_response);
        });
    }

    protected processAdmin_AddNote(response: Response): Promise<Note> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Note.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Note>(null as any);
    }

    admin_EditNote(id: string, content: string | undefined): Promise<Note> {
        let url_ = this.baseUrl + "/Notes/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (content === null)
            throw new Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_EditNote(_response);
        });
    }

    protected processAdmin_EditNote(response: Response): Promise<Note> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Note.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Note>(null as any);
    }

    admin_DeleteNote(noteId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Notes/{noteId}";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_DeleteNote(_response);
        });
    }

    protected processAdmin_DeleteNote(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    admin_GetStudentAppointments(studentId: string | undefined): Promise<Appointment[]> {
        let url_ = this.baseUrl + "/GetStudentAppointments?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_GetStudentAppointments(_response);
        });
    }

    protected processAdmin_GetStudentAppointments(response: Response): Promise<Appointment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Appointment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Appointment[]>(null as any);
    }

    admin_GetProcessedStudents(startIndex: number | undefined, pageSize: number | undefined, sortByParameter: SortParameter | null | undefined, sortDirection: SortDirection | null | undefined): Promise<PaginatedResultOfProcessedStudentsForAdvisor> {
        let url_ = this.baseUrl + "/GetProcessedStudents?";
        if (startIndex === null)
            throw new Error("The parameter 'startIndex' cannot be null.");
        else if (startIndex !== undefined)
            url_ += "startIndex=" + encodeURIComponent("" + startIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortByParameter !== undefined && sortByParameter !== null)
            url_ += "sortByParameter=" + encodeURIComponent("" + sortByParameter) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_GetProcessedStudents(_response);
        });
    }

    protected processAdmin_GetProcessedStudents(response: Response): Promise<PaginatedResultOfProcessedStudentsForAdvisor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfProcessedStudentsForAdvisor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultOfProcessedStudentsForAdvisor>(null as any);
    }

    admin_GetWaitingStudents(): Promise<DataForAdvisor[]> {
        let url_ = this.baseUrl + "/GetWaitingStudents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_GetWaitingStudents(_response);
        });
    }

    protected processAdmin_GetWaitingStudents(response: Response): Promise<DataForAdvisor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataForAdvisor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataForAdvisor[]>(null as any);
    }

    admin_CancelAppointment(appointmentId: string | undefined, userIdOfAdmin: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/CancelAppointment?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "appointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        if (userIdOfAdmin === null)
            throw new Error("The parameter 'userIdOfAdmin' cannot be null.");
        else if (userIdOfAdmin !== undefined)
            url_ += "userIdOfAdmin=" + encodeURIComponent("" + userIdOfAdmin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_CancelAppointment(_response);
        });
    }

    protected processAdmin_CancelAppointment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    admin_ProcessAppointment(appointmentId: string | undefined, userIdOfAdmin: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/ProcessAppointment?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "appointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        if (userIdOfAdmin === null)
            throw new Error("The parameter 'userIdOfAdmin' cannot be null.");
        else if (userIdOfAdmin !== undefined)
            url_ += "userIdOfAdmin=" + encodeURIComponent("" + userIdOfAdmin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_ProcessAppointment(_response);
        });
    }

    protected processAdmin_ProcessAppointment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    admin_GetStudents(skip: number | undefined, limit: number | undefined, filter: StudentsFilter): Promise<PaginatedResultOfTableStudent> {
        let url_ = this.baseUrl + "/Students?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_GetStudents(_response);
        });
    }

    protected processAdmin_GetStudents(response: Response): Promise<PaginatedResultOfTableStudent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfTableStudent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultOfTableStudent>(null as any);
    }

    admin_DummyFunctionsDataForAdvisor(dummyInput: DataForAdvisor): Promise<void> {
        let url_ = this.baseUrl + "/DataForAdvisor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dummyInput);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_DummyFunctionsDataForAdvisor(_response);
        });
    }

    protected processAdmin_DummyFunctionsDataForAdvisor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    student_SubmitStudentProfile(files: FileParameter[] | null | undefined): Promise<Student> {
        let url_ = this.baseUrl + "/StudentForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudent_SubmitStudentProfile(_response);
        });
    }

    protected processStudent_SubmitStudentProfile(response: Response): Promise<Student> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Student.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Student>(null as any);
    }

    student_EditStudentProfile(files: FileParameter[] | null | undefined): Promise<Student> {
        let url_ = this.baseUrl + "/StudentForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudent_EditStudentProfile(_response);
        });
    }

    protected processStudent_EditStudentProfile(response: Response): Promise<Student> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Student.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Student>(null as any);
    }

    student_GetResume(resumeId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Files/{ResumeId}";
        if (resumeId === undefined || resumeId === null)
            throw new Error("The parameter 'resumeId' must be defined.");
        url_ = url_.replace("{ResumeId}", encodeURIComponent("" + resumeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudent_GetResume(_response);
        });
    }

    protected processStudent_GetResume(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    student_GetStudent(studentId: string): Promise<StudentProfile> {
        let url_ = this.baseUrl + "/Students/{studentId}";
        if (studentId === undefined || studentId === null)
            throw new Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudent_GetStudent(_response);
        });
    }

    protected processStudent_GetStudent(response: Response): Promise<StudentProfile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentProfile.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentProfile>(null as any);
    }

    student_GetStudentAwards(studentUserid: string | undefined): Promise<StudentAwardProfile[]> {
        let url_ = this.baseUrl + "/GetStudentAwards?";
        if (studentUserid === null)
            throw new Error("The parameter 'studentUserid' cannot be null.");
        else if (studentUserid !== undefined)
            url_ += "studentUserid=" + encodeURIComponent("" + studentUserid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudent_GetStudentAwards(_response);
        });
    }

    protected processStudent_GetStudentAwards(response: Response): Promise<StudentAwardProfile[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudentAwardProfile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentAwardProfile[]>(null as any);
    }

    student_GetStudentNameByUId(uID: string): Promise<ResponseForCheckIn> {
        let url_ = this.baseUrl + "/StudentName/{UID}";
        if (uID === undefined || uID === null)
            throw new Error("The parameter 'uID' must be defined.");
        url_ = url_.replace("{UID}", encodeURIComponent("" + uID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudent_GetStudentNameByUId(_response);
        });
    }

    protected processStudent_GetStudentNameByUId(response: Response): Promise<ResponseForCheckIn> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseForCheckIn.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseForCheckIn>(null as any);
    }

    student_GetAdvisors(): Promise<AdvisorCheckInInfo[]> {
        let url_ = this.baseUrl + "/Advisors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudent_GetAdvisors(_response);
        });
    }

    protected processStudent_GetAdvisors(response: Response): Promise<AdvisorCheckInInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvisorCheckInInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdvisorCheckInInfo[]>(null as any);
    }

    student_CheckInStudent(student: DataToCheckIn): Promise<FileResponse> {
        let url_ = this.baseUrl + "/CheckIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(student);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudent_CheckInStudent(_response);
        });
    }

    protected processStudent_CheckInStudent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    student_DummyFunctionsCreateFormSubmission(dummyInput: CreateFormSubmission): Promise<void> {
        let url_ = this.baseUrl + "/CreateFormSubmission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dummyInput);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudent_DummyFunctionsCreateFormSubmission(_response);
        });
    }

    protected processStudent_DummyFunctionsCreateFormSubmission(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    user_CreateUser(): Promise<User> {
        let url_ = this.baseUrl + "/Users/Register";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser_CreateUser(_response);
        });
    }

    protected processUser_CreateUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    user_GetCurrentUser(): Promise<User> {
        let url_ = this.baseUrl + "/CurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser_GetCurrentUser(_response);
        });
    }

    protected processUser_GetCurrentUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    user_GetStaticData(): Promise<StaticData> {
        let url_ = this.baseUrl + "/GetStaticData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser_GetStaticData(_response);
        });
    }

    protected processUser_GetStaticData(response: Response): Promise<StaticData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaticData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StaticData>(null as any);
    }
}

export class Admin implements IAdmin {
    id?: string;
    userId?: string;
    user?: User;
    isAdvisor?: boolean;

    constructor(data?: IAdmin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.isAdvisor = _data["isAdvisor"];
        }
    }

    static fromJS(data: any): Admin {
        data = typeof data === 'object' ? data : {};
        let result = new Admin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["isAdvisor"] = this.isAdvisor;
        return data;
    }
}

export interface IAdmin {
    id?: string;
    userId?: string;
    user?: User;
    isAdvisor?: boolean;
}

export class User implements IUser {
    id?: string;
    createdAt?: DateTime;
    netID?: string;
    usfid?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    fullName?: string;
    student?: Student | undefined;
    admin?: Admin | undefined;
    appointments?: Appointment[];
    advisorAppointments?: Appointment[];
    createdNotes?: Note[];
    studentAwards?: StudentAward[] | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : <any>undefined;
            this.netID = _data["netID"];
            this.usfid = _data["usfid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : <any>undefined;
            this.admin = _data["admin"] ? Admin.fromJS(_data["admin"]) : <any>undefined;
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments!.push(Appointment.fromJS(item));
            }
            if (Array.isArray(_data["advisorAppointments"])) {
                this.advisorAppointments = [] as any;
                for (let item of _data["advisorAppointments"])
                    this.advisorAppointments!.push(Appointment.fromJS(item));
            }
            if (Array.isArray(_data["createdNotes"])) {
                this.createdNotes = [] as any;
                for (let item of _data["createdNotes"])
                    this.createdNotes!.push(Note.fromJS(item));
            }
            if (Array.isArray(_data["studentAwards"])) {
                this.studentAwards = [] as any;
                for (let item of _data["studentAwards"])
                    this.studentAwards!.push(StudentAward.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : <any>undefined;
        data["netID"] = this.netID;
        data["usfid"] = this.usfid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        data["admin"] = this.admin ? this.admin.toJSON() : <any>undefined;
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toJSON());
        }
        if (Array.isArray(this.advisorAppointments)) {
            data["advisorAppointments"] = [];
            for (let item of this.advisorAppointments)
                data["advisorAppointments"].push(item.toJSON());
        }
        if (Array.isArray(this.createdNotes)) {
            data["createdNotes"] = [];
            for (let item of this.createdNotes)
                data["createdNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.studentAwards)) {
            data["studentAwards"] = [];
            for (let item of this.studentAwards)
                data["studentAwards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUser {
    id?: string;
    createdAt?: DateTime;
    netID?: string;
    usfid?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    fullName?: string;
    student?: Student | undefined;
    admin?: Admin | undefined;
    appointments?: Appointment[];
    advisorAppointments?: Appointment[];
    createdNotes?: Note[];
    studentAwards?: StudentAward[] | undefined;
}

export class Student implements IStudent {
    id?: string;
    createdAt?: DateTime;
    modifiedAt?: DateTime;
    user?: User;
    userId?: string;
    gender?: Gender;
    race?: Race;
    campus?: Campus;
    entryTerm?: AcademicTerm;
    academicClass?: AcademicClass;
    preferredName?: string;
    preferredPronouns?: Pronouns;
    expectedGraduationYear?: number;
    expectedGraduationSemester?: Semester;
    linkedinProfile?: string | undefined;
    isUndergraduateStudent?: boolean;
    isHonorsStudent?: boolean;
    undergradGPA?: number | undefined;
    gradGPA?: number | undefined;
    college?: string;
    major1?: string;
    major2?: string | undefined;
    major3?: string | undefined;
    minor1?: string | undefined;
    minor2?: string | undefined;
    minor3?: string | undefined;
    isHonorsDepartmentProgram?: boolean;
    citizenshipStatus?: CitizenCodes;
    isTransferStudent?: boolean;
    isAthelete?: boolean;
    isVeteran?: boolean;
    addressCountry?: string | undefined;
    addressCity?: string | undefined;
    addressState?: string | undefined;
    fwspAwarded?: number | undefined;
    fwspReceived?: number | undefined;
    isFinancialAidStudent?: boolean;
    isFTICStudent?: boolean;
    isPellGrantRecipient?: boolean;
    isNationalMeritScholar?: boolean;
    wilcoxScholars?: boolean;
    kosoveSociety?: boolean;
    futureStrategies?: boolean;
    peaceCorpPrep?: boolean;
    resumeId?: string | undefined;
    academicInterests?: AcademicInterest[] | undefined;
    personalInterests?: PersonalInterest[] | undefined;
    currentActivities?: Activity[] | undefined;
    gradSchoolPlans?: YesNoMaybeAlready;
    gradSchoolAbroadPlans?: YesNoMaybeAlready;
    futureGoals?: string;
    speakForeignLanguageList?: Language[] | undefined;
    passionProjects?: string;
    knowsAboutHIPS?: YesNoMaybeAlready;
    receivedNotes?: Note[] | undefined;
    experienceList?: Experience[] | undefined;

    constructor(data?: IStudent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : <any>undefined;
            this.modifiedAt = _data["modifiedAt"] ? DateTime.fromISO(_data["modifiedAt"].toString()) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.gender = _data["gender"];
            this.race = _data["race"];
            this.campus = _data["campus"];
            this.entryTerm = _data["entryTerm"] ? AcademicTerm.fromJS(_data["entryTerm"]) : <any>undefined;
            this.academicClass = _data["academicClass"];
            this.preferredName = _data["preferredName"];
            this.preferredPronouns = _data["preferredPronouns"];
            this.expectedGraduationYear = _data["expectedGraduationYear"];
            this.expectedGraduationSemester = _data["expectedGraduationSemester"];
            this.linkedinProfile = _data["linkedinProfile"];
            this.isUndergraduateStudent = _data["isUndergraduateStudent"];
            this.isHonorsStudent = _data["isHonorsStudent"];
            this.undergradGPA = _data["undergradGPA"];
            this.gradGPA = _data["gradGPA"];
            this.college = _data["college"];
            this.major1 = _data["major1"];
            this.major2 = _data["major2"];
            this.major3 = _data["major3"];
            this.minor1 = _data["minor1"];
            this.minor2 = _data["minor2"];
            this.minor3 = _data["minor3"];
            this.isHonorsDepartmentProgram = _data["isHonorsDepartmentProgram"];
            this.citizenshipStatus = _data["citizenshipStatus"];
            this.isTransferStudent = _data["isTransferStudent"];
            this.isAthelete = _data["isAthelete"];
            this.isVeteran = _data["isVeteran"];
            this.addressCountry = _data["addressCountry"];
            this.addressCity = _data["addressCity"];
            this.addressState = _data["addressState"];
            this.fwspAwarded = _data["fwspAwarded"];
            this.fwspReceived = _data["fwspReceived"];
            this.isFinancialAidStudent = _data["isFinancialAidStudent"];
            this.isFTICStudent = _data["isFTICStudent"];
            this.isPellGrantRecipient = _data["isPellGrantRecipient"];
            this.isNationalMeritScholar = _data["isNationalMeritScholar"];
            this.wilcoxScholars = _data["wilcoxScholars"];
            this.kosoveSociety = _data["kosoveSociety"];
            this.futureStrategies = _data["futureStrategies"];
            this.peaceCorpPrep = _data["peaceCorpPrep"];
            this.resumeId = _data["resumeId"];
            if (Array.isArray(_data["academicInterests"])) {
                this.academicInterests = [] as any;
                for (let item of _data["academicInterests"])
                    this.academicInterests!.push(AcademicInterest.fromJS(item));
            }
            if (Array.isArray(_data["personalInterests"])) {
                this.personalInterests = [] as any;
                for (let item of _data["personalInterests"])
                    this.personalInterests!.push(PersonalInterest.fromJS(item));
            }
            if (Array.isArray(_data["currentActivities"])) {
                this.currentActivities = [] as any;
                for (let item of _data["currentActivities"])
                    this.currentActivities!.push(Activity.fromJS(item));
            }
            this.gradSchoolPlans = _data["gradSchoolPlans"];
            this.gradSchoolAbroadPlans = _data["gradSchoolAbroadPlans"];
            this.futureGoals = _data["futureGoals"];
            if (Array.isArray(_data["speakForeignLanguageList"])) {
                this.speakForeignLanguageList = [] as any;
                for (let item of _data["speakForeignLanguageList"])
                    this.speakForeignLanguageList!.push(Language.fromJS(item));
            }
            this.passionProjects = _data["passionProjects"];
            this.knowsAboutHIPS = _data["knowsAboutHIPS"];
            if (Array.isArray(_data["receivedNotes"])) {
                this.receivedNotes = [] as any;
                for (let item of _data["receivedNotes"])
                    this.receivedNotes!.push(Note.fromJS(item));
            }
            if (Array.isArray(_data["experienceList"])) {
                this.experienceList = [] as any;
                for (let item of _data["experienceList"])
                    this.experienceList!.push(Experience.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Student {
        data = typeof data === 'object' ? data : {};
        let result = new Student();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : <any>undefined;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["gender"] = this.gender;
        data["race"] = this.race;
        data["campus"] = this.campus;
        data["entryTerm"] = this.entryTerm ? this.entryTerm.toJSON() : <any>undefined;
        data["academicClass"] = this.academicClass;
        data["preferredName"] = this.preferredName;
        data["preferredPronouns"] = this.preferredPronouns;
        data["expectedGraduationYear"] = this.expectedGraduationYear;
        data["expectedGraduationSemester"] = this.expectedGraduationSemester;
        data["linkedinProfile"] = this.linkedinProfile;
        data["isUndergraduateStudent"] = this.isUndergraduateStudent;
        data["isHonorsStudent"] = this.isHonorsStudent;
        data["undergradGPA"] = this.undergradGPA;
        data["gradGPA"] = this.gradGPA;
        data["college"] = this.college;
        data["major1"] = this.major1;
        data["major2"] = this.major2;
        data["major3"] = this.major3;
        data["minor1"] = this.minor1;
        data["minor2"] = this.minor2;
        data["minor3"] = this.minor3;
        data["isHonorsDepartmentProgram"] = this.isHonorsDepartmentProgram;
        data["citizenshipStatus"] = this.citizenshipStatus;
        data["isTransferStudent"] = this.isTransferStudent;
        data["isAthelete"] = this.isAthelete;
        data["isVeteran"] = this.isVeteran;
        data["addressCountry"] = this.addressCountry;
        data["addressCity"] = this.addressCity;
        data["addressState"] = this.addressState;
        data["fwspAwarded"] = this.fwspAwarded;
        data["fwspReceived"] = this.fwspReceived;
        data["isFinancialAidStudent"] = this.isFinancialAidStudent;
        data["isFTICStudent"] = this.isFTICStudent;
        data["isPellGrantRecipient"] = this.isPellGrantRecipient;
        data["isNationalMeritScholar"] = this.isNationalMeritScholar;
        data["wilcoxScholars"] = this.wilcoxScholars;
        data["kosoveSociety"] = this.kosoveSociety;
        data["futureStrategies"] = this.futureStrategies;
        data["peaceCorpPrep"] = this.peaceCorpPrep;
        data["resumeId"] = this.resumeId;
        if (Array.isArray(this.academicInterests)) {
            data["academicInterests"] = [];
            for (let item of this.academicInterests)
                data["academicInterests"].push(item.toJSON());
        }
        if (Array.isArray(this.personalInterests)) {
            data["personalInterests"] = [];
            for (let item of this.personalInterests)
                data["personalInterests"].push(item.toJSON());
        }
        if (Array.isArray(this.currentActivities)) {
            data["currentActivities"] = [];
            for (let item of this.currentActivities)
                data["currentActivities"].push(item.toJSON());
        }
        data["gradSchoolPlans"] = this.gradSchoolPlans;
        data["gradSchoolAbroadPlans"] = this.gradSchoolAbroadPlans;
        data["futureGoals"] = this.futureGoals;
        if (Array.isArray(this.speakForeignLanguageList)) {
            data["speakForeignLanguageList"] = [];
            for (let item of this.speakForeignLanguageList)
                data["speakForeignLanguageList"].push(item.toJSON());
        }
        data["passionProjects"] = this.passionProjects;
        data["knowsAboutHIPS"] = this.knowsAboutHIPS;
        if (Array.isArray(this.receivedNotes)) {
            data["receivedNotes"] = [];
            for (let item of this.receivedNotes)
                data["receivedNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.experienceList)) {
            data["experienceList"] = [];
            for (let item of this.experienceList)
                data["experienceList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudent {
    id?: string;
    createdAt?: DateTime;
    modifiedAt?: DateTime;
    user?: User;
    userId?: string;
    gender?: Gender;
    race?: Race;
    campus?: Campus;
    entryTerm?: AcademicTerm;
    academicClass?: AcademicClass;
    preferredName?: string;
    preferredPronouns?: Pronouns;
    expectedGraduationYear?: number;
    expectedGraduationSemester?: Semester;
    linkedinProfile?: string | undefined;
    isUndergraduateStudent?: boolean;
    isHonorsStudent?: boolean;
    undergradGPA?: number | undefined;
    gradGPA?: number | undefined;
    college?: string;
    major1?: string;
    major2?: string | undefined;
    major3?: string | undefined;
    minor1?: string | undefined;
    minor2?: string | undefined;
    minor3?: string | undefined;
    isHonorsDepartmentProgram?: boolean;
    citizenshipStatus?: CitizenCodes;
    isTransferStudent?: boolean;
    isAthelete?: boolean;
    isVeteran?: boolean;
    addressCountry?: string | undefined;
    addressCity?: string | undefined;
    addressState?: string | undefined;
    fwspAwarded?: number | undefined;
    fwspReceived?: number | undefined;
    isFinancialAidStudent?: boolean;
    isFTICStudent?: boolean;
    isPellGrantRecipient?: boolean;
    isNationalMeritScholar?: boolean;
    wilcoxScholars?: boolean;
    kosoveSociety?: boolean;
    futureStrategies?: boolean;
    peaceCorpPrep?: boolean;
    resumeId?: string | undefined;
    academicInterests?: AcademicInterest[] | undefined;
    personalInterests?: PersonalInterest[] | undefined;
    currentActivities?: Activity[] | undefined;
    gradSchoolPlans?: YesNoMaybeAlready;
    gradSchoolAbroadPlans?: YesNoMaybeAlready;
    futureGoals?: string;
    speakForeignLanguageList?: Language[] | undefined;
    passionProjects?: string;
    knowsAboutHIPS?: YesNoMaybeAlready;
    receivedNotes?: Note[] | undefined;
    experienceList?: Experience[] | undefined;
}

export enum Gender {
    Woman = 1,
    Man = 2,
    Unknown = 3,
}

export enum Race {
    White = 1,
    Unknown = 2,
    NonResidentAlien = 3,
    Hispanic = 4,
    Black = 5,
    Asian = 6,
    Indigenous = 7,
}

export enum Campus {
    Tampa = 1,
    StPetersburg = 2,
    SarasotaManatee = 3,
}

export class AcademicTerm implements IAcademicTerm {
    semester?: Semester;
    year?: number;

    constructor(data?: IAcademicTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.semester = _data["semester"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): AcademicTerm {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["semester"] = this.semester;
        data["year"] = this.year;
        return data;
    }
}

export interface IAcademicTerm {
    semester?: Semester;
    year?: number;
}

export enum Semester {
    Spring = 0,
    Summer = 1,
    Fall = 2,
    NotProvided = 3,
}

export enum AcademicClass {
    Freshman = 1,
    Sophomore = 2,
    Junior = 3,
    Senior = 4,
    Other = 5,
}

export enum Pronouns {
    SheHer = 1,
    HeHim = 2,
    TheyThem = 3,
    Other = 4,
    NotProvided = 5,
}

export enum CitizenCodes {
    Unknown = 1,
    PermResident = 2,
    ForeignNational = 3,
    CitizenUSA = 4,
}

export class AcademicInterest implements IAcademicInterest {
    id?: string;
    name!: string;

    constructor(data?: IAcademicInterest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AcademicInterest {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicInterest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAcademicInterest {
    id?: string;
    name: string;
}

export class PersonalInterest implements IPersonalInterest {
    id?: string;
    name!: string;

    constructor(data?: IPersonalInterest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PersonalInterest {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInterest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPersonalInterest {
    id?: string;
    name: string;
}

export class Activity implements IActivity {
    id?: string;
    name!: string;

    constructor(data?: IActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Activity {
        data = typeof data === 'object' ? data : {};
        let result = new Activity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IActivity {
    id?: string;
    name: string;
}

export enum YesNoMaybeAlready {
    Yes = 1,
    No = 2,
    Maybe = 3,
    Already = 4,
    DoNotKnow = 5,
    NotProvided = 6,
}

export class Language implements ILanguage {
    id?: string;
    name!: string;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILanguage {
    id?: string;
    name: string;
}

export class Note implements INote {
    id?: string;
    createdAt?: DateTime;
    modifiedAt?: DateTime;
    content?: string;
    createdById?: string;
    attachedToId?: string;
    createdBy?: User;
    attachedTo?: Student;

    constructor(data?: INote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : <any>undefined;
            this.modifiedAt = _data["modifiedAt"] ? DateTime.fromISO(_data["modifiedAt"].toString()) : <any>undefined;
            this.content = _data["content"];
            this.createdById = _data["createdById"];
            this.attachedToId = _data["attachedToId"];
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>undefined;
            this.attachedTo = _data["attachedTo"] ? Student.fromJS(_data["attachedTo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Note {
        data = typeof data === 'object' ? data : {};
        let result = new Note();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : <any>undefined;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toString() : <any>undefined;
        data["content"] = this.content;
        data["createdById"] = this.createdById;
        data["attachedToId"] = this.attachedToId;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["attachedTo"] = this.attachedTo ? this.attachedTo.toJSON() : <any>undefined;
        return data;
    }
}

export interface INote {
    id?: string;
    createdAt?: DateTime;
    modifiedAt?: DateTime;
    content?: string;
    createdById?: string;
    attachedToId?: string;
    createdBy?: User;
    attachedTo?: Student;
}

export class Experience implements IExperience {
    id?: string;
    studentId?: string;
    student?: Student;
    type?: ExperienceType;
    title?: string;
    role?: string;
    description?: string;
    yearsNumber?: number;
    mentor?: string;

    constructor(data?: IExperience) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentId = _data["studentId"];
            this.student = _data["student"] ? Student.fromJS(_data["student"]) : <any>undefined;
            this.type = _data["type"];
            this.title = _data["title"];
            this.role = _data["role"];
            this.description = _data["description"];
            this.yearsNumber = _data["yearsNumber"];
            this.mentor = _data["mentor"];
        }
    }

    static fromJS(data: any): Experience {
        data = typeof data === 'object' ? data : {};
        let result = new Experience();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentId"] = this.studentId;
        data["student"] = this.student ? this.student.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["title"] = this.title;
        data["role"] = this.role;
        data["description"] = this.description;
        data["yearsNumber"] = this.yearsNumber;
        data["mentor"] = this.mentor;
        return data;
    }
}

export interface IExperience {
    id?: string;
    studentId?: string;
    student?: Student;
    type?: ExperienceType;
    title?: string;
    role?: string;
    description?: string;
    yearsNumber?: number;
    mentor?: string;
}

export enum ExperienceType {
    CommunityService = 1,
    StudentOrganizations = 2,
    Job = 3,
    Internship = 4,
    Research = 5,
    CreativeProjects = 6,
    Writing = 7,
    Sports = 8,
    MusicalEnsembles = 9,
    PoliticalCampaigns = 10,
    Publications = 11,
    ConferencePresentations = 12,
    StudyAbroad = 13,
    Other = 14,
}

export class Appointment implements IAppointment {
    id?: string;
    createdAt?: DateTime;
    uid?: string;
    wentToAdvisorTime?: DateTime | undefined;
    status?: AppointmentStatus;
    user?: User;
    userId?: string;
    advisorUser?: User | undefined;
    advisorId?: string | undefined;

    constructor(data?: IAppointment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : <any>undefined;
            this.uid = _data["uid"];
            this.wentToAdvisorTime = _data["wentToAdvisorTime"] ? DateTime.fromISO(_data["wentToAdvisorTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.advisorUser = _data["advisorUser"] ? User.fromJS(_data["advisorUser"]) : <any>undefined;
            this.advisorId = _data["advisorId"];
        }
    }

    static fromJS(data: any): Appointment {
        data = typeof data === 'object' ? data : {};
        let result = new Appointment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : <any>undefined;
        data["uid"] = this.uid;
        data["wentToAdvisorTime"] = this.wentToAdvisorTime ? this.wentToAdvisorTime.toString() : <any>undefined;
        data["status"] = this.status;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["advisorUser"] = this.advisorUser ? this.advisorUser.toJSON() : <any>undefined;
        data["advisorId"] = this.advisorId;
        return data;
    }
}

export interface IAppointment {
    id?: string;
    createdAt?: DateTime;
    uid?: string;
    wentToAdvisorTime?: DateTime | undefined;
    status?: AppointmentStatus;
    user?: User;
    userId?: string;
    advisorUser?: User | undefined;
    advisorId?: string | undefined;
}

export enum AppointmentStatus {
    Canceled = 0,
    Waiting = 1,
    Processed = 2,
}

export class StudentAward implements IStudentAward {
    id?: string;
    userId?: string;
    user?: User;
    academicYear?: number;
    fullAcademicYear?: string;
    collegeId?: string;
    college?: College;
    awardId?: string;
    award?: Award;
    awardStatus?: AwardStatus;
    programId?: string;
    program?: Program;
    programDetails?: string | undefined;
    isUndergraduate?: boolean;
    estimatedAmount?: number | undefined;
    isDeleted?: boolean;

    constructor(data?: IStudentAward) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.academicYear = _data["academicYear"];
            this.fullAcademicYear = _data["fullAcademicYear"];
            this.collegeId = _data["collegeId"];
            this.college = _data["college"] ? College.fromJS(_data["college"]) : <any>undefined;
            this.awardId = _data["awardId"];
            this.award = _data["award"] ? Award.fromJS(_data["award"]) : <any>undefined;
            this.awardStatus = _data["awardStatus"];
            this.programId = _data["programId"];
            this.program = _data["program"] ? Program.fromJS(_data["program"]) : <any>undefined;
            this.programDetails = _data["programDetails"];
            this.isUndergraduate = _data["isUndergraduate"];
            this.estimatedAmount = _data["estimatedAmount"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): StudentAward {
        data = typeof data === 'object' ? data : {};
        let result = new StudentAward();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["academicYear"] = this.academicYear;
        data["fullAcademicYear"] = this.fullAcademicYear;
        data["collegeId"] = this.collegeId;
        data["college"] = this.college ? this.college.toJSON() : <any>undefined;
        data["awardId"] = this.awardId;
        data["award"] = this.award ? this.award.toJSON() : <any>undefined;
        data["awardStatus"] = this.awardStatus;
        data["programId"] = this.programId;
        data["program"] = this.program ? this.program.toJSON() : <any>undefined;
        data["programDetails"] = this.programDetails;
        data["isUndergraduate"] = this.isUndergraduate;
        data["estimatedAmount"] = this.estimatedAmount;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IStudentAward {
    id?: string;
    userId?: string;
    user?: User;
    academicYear?: number;
    fullAcademicYear?: string;
    collegeId?: string;
    college?: College;
    awardId?: string;
    award?: Award;
    awardStatus?: AwardStatus;
    programId?: string;
    program?: Program;
    programDetails?: string | undefined;
    isUndergraduate?: boolean;
    estimatedAmount?: number | undefined;
    isDeleted?: boolean;
}

export class College implements ICollege {
    id?: string;
    name?: string;
    studentAwards?: StudentAward[];

    constructor(data?: ICollege) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["studentAwards"])) {
                this.studentAwards = [] as any;
                for (let item of _data["studentAwards"])
                    this.studentAwards!.push(StudentAward.fromJS(item));
            }
        }
    }

    static fromJS(data: any): College {
        data = typeof data === 'object' ? data : {};
        let result = new College();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.studentAwards)) {
            data["studentAwards"] = [];
            for (let item of this.studentAwards)
                data["studentAwards"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICollege {
    id?: string;
    name?: string;
    studentAwards?: StudentAward[];
}

export class Award implements IAward {
    id?: string;
    name?: string;
    isDeleted?: boolean;
    studentAwards?: StudentAward[];

    constructor(data?: IAward) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["studentAwards"])) {
                this.studentAwards = [] as any;
                for (let item of _data["studentAwards"])
                    this.studentAwards!.push(StudentAward.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Award {
        data = typeof data === 'object' ? data : {};
        let result = new Award();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.studentAwards)) {
            data["studentAwards"] = [];
            for (let item of this.studentAwards)
                data["studentAwards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAward {
    id?: string;
    name?: string;
    isDeleted?: boolean;
    studentAwards?: StudentAward[];
}

export enum AwardStatus {
    Accepted = 0,
    Declined = 1,
    HonorableMention = 2,
}

export class Program implements IProgram {
    id?: string;
    name?: string;
    isDeleted?: boolean;
    studentAwards?: StudentAward[];

    constructor(data?: IProgram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["studentAwards"])) {
                this.studentAwards = [] as any;
                for (let item of _data["studentAwards"])
                    this.studentAwards!.push(StudentAward.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Program {
        data = typeof data === 'object' ? data : {};
        let result = new Program();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.studentAwards)) {
            data["studentAwards"] = [];
            for (let item of this.studentAwards)
                data["studentAwards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProgram {
    id?: string;
    name?: string;
    isDeleted?: boolean;
    studentAwards?: StudentAward[];
}

export class DWStudentProfileSynchronization implements IDWStudentProfileSynchronization {
    updatedStudentsCount?: number;
    totalStudentsCount?: number;
    updateTimestamp?: string;

    constructor(data?: IDWStudentProfileSynchronization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedStudentsCount = _data["updatedStudentsCount"];
            this.totalStudentsCount = _data["totalStudentsCount"];
            this.updateTimestamp = _data["updateTimestamp"];
        }
    }

    static fromJS(data: any): DWStudentProfileSynchronization {
        data = typeof data === 'object' ? data : {};
        let result = new DWStudentProfileSynchronization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedStudentsCount"] = this.updatedStudentsCount;
        data["totalStudentsCount"] = this.totalStudentsCount;
        data["updateTimestamp"] = this.updateTimestamp;
        return data;
    }
}

export interface IDWStudentProfileSynchronization {
    updatedStudentsCount?: number;
    totalStudentsCount?: number;
    updateTimestamp?: string;
}

export class ReferenceItemDTO implements IReferenceItemDTO {
    id?: string;
    name?: string;

    constructor(data?: IReferenceItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ReferenceItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IReferenceItemDTO {
    id?: string;
    name?: string;
}

export enum ReferenceType {
    Award = 0,
    Program = 1,
}

export class StudentAwardProfile implements IStudentAwardProfile {
    id?: string;
    academicYear?: number;
    fullAcademicYear?: string;
    college?: College;
    award?: Award;
    awardStatus?: AwardStatus;
    program?: Program;
    programDetails?: string | undefined;
    isUndergraduate?: boolean;
    estimatedAmount?: number | undefined;

    constructor(data?: IStudentAwardProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.academicYear = _data["academicYear"];
            this.fullAcademicYear = _data["fullAcademicYear"];
            this.college = _data["college"] ? College.fromJS(_data["college"]) : <any>undefined;
            this.award = _data["award"] ? Award.fromJS(_data["award"]) : <any>undefined;
            this.awardStatus = _data["awardStatus"];
            this.program = _data["program"] ? Program.fromJS(_data["program"]) : <any>undefined;
            this.programDetails = _data["programDetails"];
            this.isUndergraduate = _data["isUndergraduate"];
            this.estimatedAmount = _data["estimatedAmount"];
        }
    }

    static fromJS(data: any): StudentAwardProfile {
        data = typeof data === 'object' ? data : {};
        let result = new StudentAwardProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["academicYear"] = this.academicYear;
        data["fullAcademicYear"] = this.fullAcademicYear;
        data["college"] = this.college ? this.college.toJSON() : <any>undefined;
        data["award"] = this.award ? this.award.toJSON() : <any>undefined;
        data["awardStatus"] = this.awardStatus;
        data["program"] = this.program ? this.program.toJSON() : <any>undefined;
        data["programDetails"] = this.programDetails;
        data["isUndergraduate"] = this.isUndergraduate;
        data["estimatedAmount"] = this.estimatedAmount;
        return data;
    }
}

export interface IStudentAwardProfile {
    id?: string;
    academicYear?: number;
    fullAcademicYear?: string;
    college?: College;
    award?: Award;
    awardStatus?: AwardStatus;
    program?: Program;
    programDetails?: string | undefined;
    isUndergraduate?: boolean;
    estimatedAmount?: number | undefined;
}

export class StudentAwardDTO implements IStudentAwardDTO {
    netID?: string;
    startAcademicYear?: number;
    collegeId?: string;
    awardId?: string;
    awardStatus?: AwardStatus;
    programId?: string;
    programDetails?: string | undefined;
    isUndergraduate?: boolean;
    estimatedAmount?: number | undefined;

    constructor(data?: IStudentAwardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.netID = _data["netID"];
            this.startAcademicYear = _data["startAcademicYear"];
            this.collegeId = _data["collegeId"];
            this.awardId = _data["awardId"];
            this.awardStatus = _data["awardStatus"];
            this.programId = _data["programId"];
            this.programDetails = _data["programDetails"];
            this.isUndergraduate = _data["isUndergraduate"];
            this.estimatedAmount = _data["estimatedAmount"];
        }
    }

    static fromJS(data: any): StudentAwardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StudentAwardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["netID"] = this.netID;
        data["startAcademicYear"] = this.startAcademicYear;
        data["collegeId"] = this.collegeId;
        data["awardId"] = this.awardId;
        data["awardStatus"] = this.awardStatus;
        data["programId"] = this.programId;
        data["programDetails"] = this.programDetails;
        data["isUndergraduate"] = this.isUndergraduate;
        data["estimatedAmount"] = this.estimatedAmount;
        return data;
    }
}

export interface IStudentAwardDTO {
    netID?: string;
    startAcademicYear?: number;
    collegeId?: string;
    awardId?: string;
    awardStatus?: AwardStatus;
    programId?: string;
    programDetails?: string | undefined;
    isUndergraduate?: boolean;
    estimatedAmount?: number | undefined;
}

export class NotesWithAuthor implements INotesWithAuthor {
    noteId?: string;
    content?: string;
    createdById?: string;
    attachedToId?: string;
    advisorFullname?: string;
    createdAt?: DateTime;
    modifiedAt?: DateTime;

    constructor(data?: INotesWithAuthor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteId = _data["noteId"];
            this.content = _data["content"];
            this.createdById = _data["createdById"];
            this.attachedToId = _data["attachedToId"];
            this.advisorFullname = _data["advisorFullname"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : <any>undefined;
            this.modifiedAt = _data["modifiedAt"] ? DateTime.fromISO(_data["modifiedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotesWithAuthor {
        data = typeof data === 'object' ? data : {};
        let result = new NotesWithAuthor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteId"] = this.noteId;
        data["content"] = this.content;
        data["createdById"] = this.createdById;
        data["attachedToId"] = this.attachedToId;
        data["advisorFullname"] = this.advisorFullname;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : <any>undefined;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toString() : <any>undefined;
        return data;
    }
}

export interface INotesWithAuthor {
    noteId?: string;
    content?: string;
    createdById?: string;
    attachedToId?: string;
    advisorFullname?: string;
    createdAt?: DateTime;
    modifiedAt?: DateTime;
}

export class PaginatedResultOfProcessedStudentsForAdvisor implements IPaginatedResultOfProcessedStudentsForAdvisor {
    count?: number;
    results?: ProcessedStudentsForAdvisor[];

    constructor(data?: IPaginatedResultOfProcessedStudentsForAdvisor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProcessedStudentsForAdvisor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfProcessedStudentsForAdvisor {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfProcessedStudentsForAdvisor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultOfProcessedStudentsForAdvisor {
    count?: number;
    results?: ProcessedStudentsForAdvisor[];
}

export class ProcessedStudentsForAdvisor implements IProcessedStudentsForAdvisor {
    joinedQueueAt?: DateTime;
    checkInSince?: DateTime | undefined;
    uIdStudent?: string;
    appointmentId?: string;
    fullName?: string;
    advisorFullName?: string;

    constructor(data?: IProcessedStudentsForAdvisor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.joinedQueueAt = _data["joinedQueueAt"] ? DateTime.fromISO(_data["joinedQueueAt"].toString()) : <any>undefined;
            this.checkInSince = _data["checkInSince"] ? DateTime.fromISO(_data["checkInSince"].toString()) : <any>undefined;
            this.uIdStudent = _data["uIdStudent"];
            this.appointmentId = _data["appointmentId"];
            this.fullName = _data["fullName"];
            this.advisorFullName = _data["advisorFullName"];
        }
    }

    static fromJS(data: any): ProcessedStudentsForAdvisor {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedStudentsForAdvisor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["joinedQueueAt"] = this.joinedQueueAt ? this.joinedQueueAt.toString() : <any>undefined;
        data["checkInSince"] = this.checkInSince ? this.checkInSince.toString() : <any>undefined;
        data["uIdStudent"] = this.uIdStudent;
        data["appointmentId"] = this.appointmentId;
        data["fullName"] = this.fullName;
        data["advisorFullName"] = this.advisorFullName;
        return data;
    }
}

export interface IProcessedStudentsForAdvisor {
    joinedQueueAt?: DateTime;
    checkInSince?: DateTime | undefined;
    uIdStudent?: string;
    appointmentId?: string;
    fullName?: string;
    advisorFullName?: string;
}

export enum SortParameter {
    JoinedQueue = 0,
    ProcessedTime = 1,
}

export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}

export class DataForAdvisor implements IDataForAdvisor {
    checkInSince?: DateTime;
    uIdStudent?: string;
    appointmentId?: string;
    fullName?: string;
    studentId?: string;
    advisorFullName?: string;

    constructor(data?: IDataForAdvisor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkInSince = _data["checkInSince"] ? DateTime.fromISO(_data["checkInSince"].toString()) : <any>undefined;
            this.uIdStudent = _data["uIdStudent"];
            this.appointmentId = _data["appointmentId"];
            this.fullName = _data["fullName"];
            this.studentId = _data["studentId"];
            this.advisorFullName = _data["advisorFullName"];
        }
    }

    static fromJS(data: any): DataForAdvisor {
        data = typeof data === 'object' ? data : {};
        let result = new DataForAdvisor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkInSince"] = this.checkInSince ? this.checkInSince.toString() : <any>undefined;
        data["uIdStudent"] = this.uIdStudent;
        data["appointmentId"] = this.appointmentId;
        data["fullName"] = this.fullName;
        data["studentId"] = this.studentId;
        data["advisorFullName"] = this.advisorFullName;
        return data;
    }
}

export interface IDataForAdvisor {
    checkInSince?: DateTime;
    uIdStudent?: string;
    appointmentId?: string;
    fullName?: string;
    studentId?: string;
    advisorFullName?: string;
}

export class PaginatedResultOfTableStudent implements IPaginatedResultOfTableStudent {
    count?: number;
    results?: TableStudent[];

    constructor(data?: IPaginatedResultOfTableStudent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TableStudent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfTableStudent {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfTableStudent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultOfTableStudent {
    count?: number;
    results?: TableStudent[];
}

export class TableStudent implements ITableStudent {
    studentId?: string;
    userId?: string;
    usfId?: string;
    fullName?: string;
    netId?: string;
    expectedGraduationYear?: number;
    expectedGraduationSemester?: Semester | undefined;
    createdAt?: DateTime;
    campus?: Campus;
    majors?: string[];

    constructor(data?: ITableStudent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.userId = _data["userId"];
            this.usfId = _data["usfId"];
            this.fullName = _data["fullName"];
            this.netId = _data["netId"];
            this.expectedGraduationYear = _data["expectedGraduationYear"];
            this.expectedGraduationSemester = _data["expectedGraduationSemester"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : <any>undefined;
            this.campus = _data["campus"];
            if (Array.isArray(_data["majors"])) {
                this.majors = [] as any;
                for (let item of _data["majors"])
                    this.majors!.push(item);
            }
        }
    }

    static fromJS(data: any): TableStudent {
        data = typeof data === 'object' ? data : {};
        let result = new TableStudent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["userId"] = this.userId;
        data["usfId"] = this.usfId;
        data["fullName"] = this.fullName;
        data["netId"] = this.netId;
        data["expectedGraduationYear"] = this.expectedGraduationYear;
        data["expectedGraduationSemester"] = this.expectedGraduationSemester;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : <any>undefined;
        data["campus"] = this.campus;
        if (Array.isArray(this.majors)) {
            data["majors"] = [];
            for (let item of this.majors)
                data["majors"].push(item);
        }
        return data;
    }
}

export interface ITableStudent {
    studentId?: string;
    userId?: string;
    usfId?: string;
    fullName?: string;
    netId?: string;
    expectedGraduationYear?: number;
    expectedGraduationSemester?: Semester | undefined;
    createdAt?: DateTime;
    campus?: Campus;
    majors?: string[];
}

export class StudentsFilter implements IStudentsFilter {
    name?: string | undefined;
    major?: string | undefined;
    usfid?: string | undefined;
    netID?: string | undefined;
    studentType?: string[] | undefined;
    campus?: Campus | undefined;
    admissionScholarships?: string[] | undefined;
    professionalInterest?: string[] | undefined;
    personalInterest?: string[] | undefined;
    languagesSpoken?: string[] | undefined;
    languagesStudied?: string[] | undefined;
    minimumGPA?: number | undefined;
    minimumSemestersCompleted?: number | undefined;
    lastLoginAfter?: DateTime | undefined;
    expectedGraduationAfter?: string[] | undefined;
    interestInGraduateSchool?: boolean | undefined;
    interestInGraduateSchoolAbroad?: boolean | undefined;
    hasGraduated?: boolean | undefined;
    isUndergraduateStudent?: boolean | undefined;
    isInterestedInResearch?: boolean | undefined;
    isInvolvedInResearch?: boolean | undefined;
    hasStudiedAbroad?: boolean | undefined;
    interestInStudyAbroad?: boolean | undefined;

    constructor(data?: IStudentsFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.major = _data["major"];
            this.usfid = _data["usfid"];
            this.netID = _data["netID"];
            if (Array.isArray(_data["studentType"])) {
                this.studentType = [] as any;
                for (let item of _data["studentType"])
                    this.studentType!.push(item);
            }
            this.campus = _data["campus"];
            if (Array.isArray(_data["admissionScholarships"])) {
                this.admissionScholarships = [] as any;
                for (let item of _data["admissionScholarships"])
                    this.admissionScholarships!.push(item);
            }
            if (Array.isArray(_data["professionalInterest"])) {
                this.professionalInterest = [] as any;
                for (let item of _data["professionalInterest"])
                    this.professionalInterest!.push(item);
            }
            if (Array.isArray(_data["personalInterest"])) {
                this.personalInterest = [] as any;
                for (let item of _data["personalInterest"])
                    this.personalInterest!.push(item);
            }
            if (Array.isArray(_data["languagesSpoken"])) {
                this.languagesSpoken = [] as any;
                for (let item of _data["languagesSpoken"])
                    this.languagesSpoken!.push(item);
            }
            if (Array.isArray(_data["languagesStudied"])) {
                this.languagesStudied = [] as any;
                for (let item of _data["languagesStudied"])
                    this.languagesStudied!.push(item);
            }
            this.minimumGPA = _data["minimumGPA"];
            this.minimumSemestersCompleted = _data["minimumSemestersCompleted"];
            this.lastLoginAfter = _data["lastLoginAfter"] ? DateTime.fromISO(_data["lastLoginAfter"].toString()) : <any>undefined;
            if (Array.isArray(_data["expectedGraduationAfter"])) {
                this.expectedGraduationAfter = [] as any;
                for (let item of _data["expectedGraduationAfter"])
                    this.expectedGraduationAfter!.push(item);
            }
            this.interestInGraduateSchool = _data["interestInGraduateSchool"];
            this.interestInGraduateSchoolAbroad = _data["interestInGraduateSchoolAbroad"];
            this.hasGraduated = _data["hasGraduated"];
            this.isUndergraduateStudent = _data["isUndergraduateStudent"];
            this.isInterestedInResearch = _data["isInterestedInResearch"];
            this.isInvolvedInResearch = _data["isInvolvedInResearch"];
            this.hasStudiedAbroad = _data["hasStudiedAbroad"];
            this.interestInStudyAbroad = _data["interestInStudyAbroad"];
        }
    }

    static fromJS(data: any): StudentsFilter {
        data = typeof data === 'object' ? data : {};
        let result = new StudentsFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["major"] = this.major;
        data["usfid"] = this.usfid;
        data["netID"] = this.netID;
        if (Array.isArray(this.studentType)) {
            data["studentType"] = [];
            for (let item of this.studentType)
                data["studentType"].push(item);
        }
        data["campus"] = this.campus;
        if (Array.isArray(this.admissionScholarships)) {
            data["admissionScholarships"] = [];
            for (let item of this.admissionScholarships)
                data["admissionScholarships"].push(item);
        }
        if (Array.isArray(this.professionalInterest)) {
            data["professionalInterest"] = [];
            for (let item of this.professionalInterest)
                data["professionalInterest"].push(item);
        }
        if (Array.isArray(this.personalInterest)) {
            data["personalInterest"] = [];
            for (let item of this.personalInterest)
                data["personalInterest"].push(item);
        }
        if (Array.isArray(this.languagesSpoken)) {
            data["languagesSpoken"] = [];
            for (let item of this.languagesSpoken)
                data["languagesSpoken"].push(item);
        }
        if (Array.isArray(this.languagesStudied)) {
            data["languagesStudied"] = [];
            for (let item of this.languagesStudied)
                data["languagesStudied"].push(item);
        }
        data["minimumGPA"] = this.minimumGPA;
        data["minimumSemestersCompleted"] = this.minimumSemestersCompleted;
        data["lastLoginAfter"] = this.lastLoginAfter ? this.lastLoginAfter.toString() : <any>undefined;
        if (Array.isArray(this.expectedGraduationAfter)) {
            data["expectedGraduationAfter"] = [];
            for (let item of this.expectedGraduationAfter)
                data["expectedGraduationAfter"].push(item);
        }
        data["interestInGraduateSchool"] = this.interestInGraduateSchool;
        data["interestInGraduateSchoolAbroad"] = this.interestInGraduateSchoolAbroad;
        data["hasGraduated"] = this.hasGraduated;
        data["isUndergraduateStudent"] = this.isUndergraduateStudent;
        data["isInterestedInResearch"] = this.isInterestedInResearch;
        data["isInvolvedInResearch"] = this.isInvolvedInResearch;
        data["hasStudiedAbroad"] = this.hasStudiedAbroad;
        data["interestInStudyAbroad"] = this.interestInStudyAbroad;
        return data;
    }
}

export interface IStudentsFilter {
    name?: string | undefined;
    major?: string | undefined;
    usfid?: string | undefined;
    netID?: string | undefined;
    studentType?: string[] | undefined;
    campus?: Campus | undefined;
    admissionScholarships?: string[] | undefined;
    professionalInterest?: string[] | undefined;
    personalInterest?: string[] | undefined;
    languagesSpoken?: string[] | undefined;
    languagesStudied?: string[] | undefined;
    minimumGPA?: number | undefined;
    minimumSemestersCompleted?: number | undefined;
    lastLoginAfter?: DateTime | undefined;
    expectedGraduationAfter?: string[] | undefined;
    interestInGraduateSchool?: boolean | undefined;
    interestInGraduateSchoolAbroad?: boolean | undefined;
    hasGraduated?: boolean | undefined;
    isUndergraduateStudent?: boolean | undefined;
    isInterestedInResearch?: boolean | undefined;
    isInvolvedInResearch?: boolean | undefined;
    hasStudiedAbroad?: boolean | undefined;
    interestInStudyAbroad?: boolean | undefined;
}

export class StudentProfile implements IStudentProfile {
    user?: User;
    gender?: Gender;
    race?: Race;
    campus?: Campus;
    entryTerm?: AcademicTerm;
    academicClass?: AcademicClass;
    preferredName?: string;
    preferredPronouns?: Pronouns;
    expectedGraduationYear?: number;
    expectedGraduationSemester?: Semester;
    linkedinProfile?: string | undefined;
    isUndergraduateStudent?: boolean;
    isHonorsStudent?: boolean;
    undergradGPA?: number | undefined;
    gradGPA?: number | undefined;
    college?: string;
    major1?: string;
    major2?: string | undefined;
    major3?: string | undefined;
    minor1?: string | undefined;
    minor2?: string | undefined;
    minor3?: string | undefined;
    isHonorsDepartmentProgram?: boolean;
    citizenshipStatus?: CitizenCodes;
    isTransferStudent?: boolean;
    isAthelete?: boolean;
    isVeteran?: boolean;
    addressCountry?: string | undefined;
    addressCity?: string | undefined;
    addressState?: string | undefined;
    fwspAwarded?: number | undefined;
    fwspReceived?: number | undefined;
    isFinancialAidStudent?: boolean;
    isFTICStudent?: boolean;
    isPellGrantRecipient?: boolean;
    isNationalMeritScholar?: boolean;
    wilcoxScholars?: boolean;
    kosoveSociety?: boolean;
    futureStrategies?: boolean;
    peaceCorpPrep?: boolean;
    resumeId?: string | undefined;
    academicInterests?: AcademicInterest[] | undefined;
    personalInterests?: PersonalInterest[] | undefined;
    currentActivities?: Activity[] | undefined;
    gradSchoolPlans?: YesNoMaybeAlready;
    gradSchoolAbroadPlans?: YesNoMaybeAlready;
    futureGoals?: string;
    speakForeignLanguageList?: Language[] | undefined;
    passionProjects?: string;
    knowsAboutHIPS?: YesNoMaybeAlready;
    receivedNotes?: Note[] | undefined;
    experienceList?: Experience[] | undefined;
    awardList?: StudentAwardProfile[] | undefined;

    constructor(data?: IStudentProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.gender = _data["gender"];
            this.race = _data["race"];
            this.campus = _data["campus"];
            this.entryTerm = _data["entryTerm"] ? AcademicTerm.fromJS(_data["entryTerm"]) : <any>undefined;
            this.academicClass = _data["academicClass"];
            this.preferredName = _data["preferredName"];
            this.preferredPronouns = _data["preferredPronouns"];
            this.expectedGraduationYear = _data["expectedGraduationYear"];
            this.expectedGraduationSemester = _data["expectedGraduationSemester"];
            this.linkedinProfile = _data["linkedinProfile"];
            this.isUndergraduateStudent = _data["isUndergraduateStudent"];
            this.isHonorsStudent = _data["isHonorsStudent"];
            this.undergradGPA = _data["undergradGPA"];
            this.gradGPA = _data["gradGPA"];
            this.college = _data["college"];
            this.major1 = _data["major1"];
            this.major2 = _data["major2"];
            this.major3 = _data["major3"];
            this.minor1 = _data["minor1"];
            this.minor2 = _data["minor2"];
            this.minor3 = _data["minor3"];
            this.isHonorsDepartmentProgram = _data["isHonorsDepartmentProgram"];
            this.citizenshipStatus = _data["citizenshipStatus"];
            this.isTransferStudent = _data["isTransferStudent"];
            this.isAthelete = _data["isAthelete"];
            this.isVeteran = _data["isVeteran"];
            this.addressCountry = _data["addressCountry"];
            this.addressCity = _data["addressCity"];
            this.addressState = _data["addressState"];
            this.fwspAwarded = _data["fwspAwarded"];
            this.fwspReceived = _data["fwspReceived"];
            this.isFinancialAidStudent = _data["isFinancialAidStudent"];
            this.isFTICStudent = _data["isFTICStudent"];
            this.isPellGrantRecipient = _data["isPellGrantRecipient"];
            this.isNationalMeritScholar = _data["isNationalMeritScholar"];
            this.wilcoxScholars = _data["wilcoxScholars"];
            this.kosoveSociety = _data["kosoveSociety"];
            this.futureStrategies = _data["futureStrategies"];
            this.peaceCorpPrep = _data["peaceCorpPrep"];
            this.resumeId = _data["resumeId"];
            if (Array.isArray(_data["academicInterests"])) {
                this.academicInterests = [] as any;
                for (let item of _data["academicInterests"])
                    this.academicInterests!.push(AcademicInterest.fromJS(item));
            }
            if (Array.isArray(_data["personalInterests"])) {
                this.personalInterests = [] as any;
                for (let item of _data["personalInterests"])
                    this.personalInterests!.push(PersonalInterest.fromJS(item));
            }
            if (Array.isArray(_data["currentActivities"])) {
                this.currentActivities = [] as any;
                for (let item of _data["currentActivities"])
                    this.currentActivities!.push(Activity.fromJS(item));
            }
            this.gradSchoolPlans = _data["gradSchoolPlans"];
            this.gradSchoolAbroadPlans = _data["gradSchoolAbroadPlans"];
            this.futureGoals = _data["futureGoals"];
            if (Array.isArray(_data["speakForeignLanguageList"])) {
                this.speakForeignLanguageList = [] as any;
                for (let item of _data["speakForeignLanguageList"])
                    this.speakForeignLanguageList!.push(Language.fromJS(item));
            }
            this.passionProjects = _data["passionProjects"];
            this.knowsAboutHIPS = _data["knowsAboutHIPS"];
            if (Array.isArray(_data["receivedNotes"])) {
                this.receivedNotes = [] as any;
                for (let item of _data["receivedNotes"])
                    this.receivedNotes!.push(Note.fromJS(item));
            }
            if (Array.isArray(_data["experienceList"])) {
                this.experienceList = [] as any;
                for (let item of _data["experienceList"])
                    this.experienceList!.push(Experience.fromJS(item));
            }
            if (Array.isArray(_data["awardList"])) {
                this.awardList = [] as any;
                for (let item of _data["awardList"])
                    this.awardList!.push(StudentAwardProfile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentProfile {
        data = typeof data === 'object' ? data : {};
        let result = new StudentProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["gender"] = this.gender;
        data["race"] = this.race;
        data["campus"] = this.campus;
        data["entryTerm"] = this.entryTerm ? this.entryTerm.toJSON() : <any>undefined;
        data["academicClass"] = this.academicClass;
        data["preferredName"] = this.preferredName;
        data["preferredPronouns"] = this.preferredPronouns;
        data["expectedGraduationYear"] = this.expectedGraduationYear;
        data["expectedGraduationSemester"] = this.expectedGraduationSemester;
        data["linkedinProfile"] = this.linkedinProfile;
        data["isUndergraduateStudent"] = this.isUndergraduateStudent;
        data["isHonorsStudent"] = this.isHonorsStudent;
        data["undergradGPA"] = this.undergradGPA;
        data["gradGPA"] = this.gradGPA;
        data["college"] = this.college;
        data["major1"] = this.major1;
        data["major2"] = this.major2;
        data["major3"] = this.major3;
        data["minor1"] = this.minor1;
        data["minor2"] = this.minor2;
        data["minor3"] = this.minor3;
        data["isHonorsDepartmentProgram"] = this.isHonorsDepartmentProgram;
        data["citizenshipStatus"] = this.citizenshipStatus;
        data["isTransferStudent"] = this.isTransferStudent;
        data["isAthelete"] = this.isAthelete;
        data["isVeteran"] = this.isVeteran;
        data["addressCountry"] = this.addressCountry;
        data["addressCity"] = this.addressCity;
        data["addressState"] = this.addressState;
        data["fwspAwarded"] = this.fwspAwarded;
        data["fwspReceived"] = this.fwspReceived;
        data["isFinancialAidStudent"] = this.isFinancialAidStudent;
        data["isFTICStudent"] = this.isFTICStudent;
        data["isPellGrantRecipient"] = this.isPellGrantRecipient;
        data["isNationalMeritScholar"] = this.isNationalMeritScholar;
        data["wilcoxScholars"] = this.wilcoxScholars;
        data["kosoveSociety"] = this.kosoveSociety;
        data["futureStrategies"] = this.futureStrategies;
        data["peaceCorpPrep"] = this.peaceCorpPrep;
        data["resumeId"] = this.resumeId;
        if (Array.isArray(this.academicInterests)) {
            data["academicInterests"] = [];
            for (let item of this.academicInterests)
                data["academicInterests"].push(item.toJSON());
        }
        if (Array.isArray(this.personalInterests)) {
            data["personalInterests"] = [];
            for (let item of this.personalInterests)
                data["personalInterests"].push(item.toJSON());
        }
        if (Array.isArray(this.currentActivities)) {
            data["currentActivities"] = [];
            for (let item of this.currentActivities)
                data["currentActivities"].push(item.toJSON());
        }
        data["gradSchoolPlans"] = this.gradSchoolPlans;
        data["gradSchoolAbroadPlans"] = this.gradSchoolAbroadPlans;
        data["futureGoals"] = this.futureGoals;
        if (Array.isArray(this.speakForeignLanguageList)) {
            data["speakForeignLanguageList"] = [];
            for (let item of this.speakForeignLanguageList)
                data["speakForeignLanguageList"].push(item.toJSON());
        }
        data["passionProjects"] = this.passionProjects;
        data["knowsAboutHIPS"] = this.knowsAboutHIPS;
        if (Array.isArray(this.receivedNotes)) {
            data["receivedNotes"] = [];
            for (let item of this.receivedNotes)
                data["receivedNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.experienceList)) {
            data["experienceList"] = [];
            for (let item of this.experienceList)
                data["experienceList"].push(item.toJSON());
        }
        if (Array.isArray(this.awardList)) {
            data["awardList"] = [];
            for (let item of this.awardList)
                data["awardList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudentProfile {
    user?: User;
    gender?: Gender;
    race?: Race;
    campus?: Campus;
    entryTerm?: AcademicTerm;
    academicClass?: AcademicClass;
    preferredName?: string;
    preferredPronouns?: Pronouns;
    expectedGraduationYear?: number;
    expectedGraduationSemester?: Semester;
    linkedinProfile?: string | undefined;
    isUndergraduateStudent?: boolean;
    isHonorsStudent?: boolean;
    undergradGPA?: number | undefined;
    gradGPA?: number | undefined;
    college?: string;
    major1?: string;
    major2?: string | undefined;
    major3?: string | undefined;
    minor1?: string | undefined;
    minor2?: string | undefined;
    minor3?: string | undefined;
    isHonorsDepartmentProgram?: boolean;
    citizenshipStatus?: CitizenCodes;
    isTransferStudent?: boolean;
    isAthelete?: boolean;
    isVeteran?: boolean;
    addressCountry?: string | undefined;
    addressCity?: string | undefined;
    addressState?: string | undefined;
    fwspAwarded?: number | undefined;
    fwspReceived?: number | undefined;
    isFinancialAidStudent?: boolean;
    isFTICStudent?: boolean;
    isPellGrantRecipient?: boolean;
    isNationalMeritScholar?: boolean;
    wilcoxScholars?: boolean;
    kosoveSociety?: boolean;
    futureStrategies?: boolean;
    peaceCorpPrep?: boolean;
    resumeId?: string | undefined;
    academicInterests?: AcademicInterest[] | undefined;
    personalInterests?: PersonalInterest[] | undefined;
    currentActivities?: Activity[] | undefined;
    gradSchoolPlans?: YesNoMaybeAlready;
    gradSchoolAbroadPlans?: YesNoMaybeAlready;
    futureGoals?: string;
    speakForeignLanguageList?: Language[] | undefined;
    passionProjects?: string;
    knowsAboutHIPS?: YesNoMaybeAlready;
    receivedNotes?: Note[] | undefined;
    experienceList?: Experience[] | undefined;
    awardList?: StudentAwardProfile[] | undefined;
}

export class ResponseForCheckIn implements IResponseForCheckIn {
    fullName?: string;
    id?: string;

    constructor(data?: IResponseForCheckIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ResponseForCheckIn {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseForCheckIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        return data;
    }
}

export interface IResponseForCheckIn {
    fullName?: string;
    id?: string;
}

export class AdvisorCheckInInfo implements IAdvisorCheckInInfo {
    userId?: string;
    fullName?: string;

    constructor(data?: IAdvisorCheckInInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): AdvisorCheckInInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AdvisorCheckInInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IAdvisorCheckInInfo {
    userId?: string;
    fullName?: string;
}

export class DataToCheckIn implements IDataToCheckIn {
    userId?: string;
    uid?: string;
    advisorId?: string;

    constructor(data?: IDataToCheckIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.uid = _data["uid"];
            this.advisorId = _data["advisorId"];
        }
    }

    static fromJS(data: any): DataToCheckIn {
        data = typeof data === 'object' ? data : {};
        let result = new DataToCheckIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["uid"] = this.uid;
        data["advisorId"] = this.advisorId;
        return data;
    }
}

export interface IDataToCheckIn {
    userId?: string;
    uid?: string;
    advisorId?: string;
}

export class CreateFormSubmission implements ICreateFormSubmission {
    userId?: string;
    contents?: Student;

    constructor(data?: ICreateFormSubmission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.contents = _data["contents"] ? Student.fromJS(_data["contents"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFormSubmission {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormSubmission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["contents"] = this.contents ? this.contents.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateFormSubmission {
    userId?: string;
    contents?: Student;
}

export class StaticData implements IStaticData {
    languages?: Language[];
    personalInterests?: PersonalInterest[];
    academicInterests?: AcademicInterest[];
    activities?: Activity[];

    constructor(data?: IStaticData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(Language.fromJS(item));
            }
            if (Array.isArray(_data["personalInterests"])) {
                this.personalInterests = [] as any;
                for (let item of _data["personalInterests"])
                    this.personalInterests!.push(PersonalInterest.fromJS(item));
            }
            if (Array.isArray(_data["academicInterests"])) {
                this.academicInterests = [] as any;
                for (let item of _data["academicInterests"])
                    this.academicInterests!.push(AcademicInterest.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(Activity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StaticData {
        data = typeof data === 'object' ? data : {};
        let result = new StaticData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        if (Array.isArray(this.personalInterests)) {
            data["personalInterests"] = [];
            for (let item of this.personalInterests)
                data["personalInterests"].push(item.toJSON());
        }
        if (Array.isArray(this.academicInterests)) {
            data["academicInterests"] = [];
            for (let item of this.academicInterests)
                data["academicInterests"].push(item.toJSON());
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStaticData {
    languages?: Language[];
    personalInterests?: PersonalInterest[];
    academicInterests?: AcademicInterest[];
    activities?: Activity[];
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}